/**
 * Black Friday pages only (snippets/bf-page-kit.liquid): makes the theme's FAQ (collapsible-content) usable with the
 * keyboard and screen readers. The theme opens a row on any click inside it; here each question becomes a button with
 * aria-expanded, Enter/Space work, and clicks inside an open answer (selecting text, links) no longer close it.
 */
(function () {
  function setupRow(row, n) {
    if (row._bf) return;
    row._bf = true;
    var q = row.querySelector(".collapsible-row__question");
    var a = row.querySelector(".collapsible-row__answer");
    if (!q || !a) return;
    if (!a.id) a.id = "bf-faq-answer-" + n;
    q.setAttribute("role", "button");
    q.setAttribute("tabindex", "0");
    q.setAttribute("aria-controls", a.id);

    function sync() {
      q.setAttribute("aria-expanded", row.classList.contains("collapsible-row--active") ? "true" : "false");
    }
    sync();
    new MutationObserver(sync).observe(row, { attributes: true, attributeFilter: ["class"] });

    q.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        q.click();
      }
    });
    a.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  function init() {
    if (!document.querySelector(".bf-page")) return;
    Array.prototype.forEach.call(document.querySelectorAll("#MainContent .collapsible-row"), setupRow);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
